module.exports = __webpack_public_path__ + "resources/img/img_datatransporter.48080911d59ae32b3ba05245f29ebb0d.png";